import { Box, Divider, InputAdornment, TextField } from '@mui/material';
import { Control, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../../../common/auth/PermissionsContext';
import { FormNumberInput } from '../../../../../component/form/FormNumberInput';
import { FinancesDrawerFormValues } from '../RightDrawerSchema';

type Props = {
  control: Control<FinancesDrawerFormValues>;
};

export const FinancesNormalPriceView = ({ control }: Props) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  const isInternalUser = hasPermission('Unrestricted', 'Impersonate');

  const campaignPriceAmount = useWatch({
    control,
    name: 'service.apiconPriceForm.campaignPriceAmount',
  });
  const duration = useWatch({ control, name: 'service.duration' });

  const campaignDiscount =
    isInternalUser && campaignPriceAmount != null && duration
      ? campaignPriceAmount / duration
      : null;
  const showCampaignDiscount = campaignDiscount != null;

  return (
    <>
      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.priceGross"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateIncludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.priceNet"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateExcludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.vatAsValue"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.VAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      {showCampaignDiscount && <Divider orientation="vertical" flexItem />}

      {showCampaignDiscount && (
        <Box sx={{ ml: '8%' }}>
          <TextField
            variant="standard"
            label=""
            helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.campaignDiscount')}
            value={campaignDiscount?.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            InputProps={{
              startAdornment: <InputAdornment position="start">€</InputAdornment>,
              disableUnderline: true,
            }}
            InputLabelProps={{ shrink: true }}
            disabled
          />
        </Box>
      )}
    </>
  );
};
